import React,{ useState } from "react";
import LogoImg from "../assets/images/common/main-logo.png"
import Bgright from "../assets/images/bg/bg-right.png"
import LogoIta from "../assets/images/logos/LOGO-ITA.png"

const LayoutHeader = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark fixed-top header">
            <div className="navbar-header ps-3">
                <button className="navbar-toggler me-2 d-inline-block" type="button" onClick={handleToggle}>
                    <span className="navbar-toggler-icon leftmenutrigger"></span>
                </button>
                <a className="navbar-brand text-start p-0 m-0" href="/">
                    <img src={LogoImg} className="zoo-logo" />
                    <div className="header-name">
                        <strong className="header-text-title">องค์การสวนสัตว์แห่งประเทศไทย ในพระบรมราชูปถัมภ์</strong><br />
                        <small style={{ fontSize: "80%", fontWeight: "400" }}>THE ZOOLOGICAL PARK ORGANIZATION
                        <br />UNDER THE ROYAL PATRONAGE OF H.M. THE KING</small>
                    </div>
                </a>
                <div className="collapse navbar-collapse text-start" id="ita-menu">
                    <ul className={`navbar-nav animate side-nav ${isOpen && "open"}`}>
                        <li className="nav-item">
                            <a className="nav-link" href="/procurement">ข้อมูลจัดซื้อจัดจ้าง</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://infocenter.oic.go.th/%E0%B8%AD%E0%B8%87%E0%B8%84%E0%B9%8C%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%A7%E0%B8%99%E0%B8%AA%E0%B8%B1%E0%B8%95%E0%B8%A7%E0%B9%8C/indexm7.php">ศูนย์ข้อมูลข่าวสารอิเล็กทรอนิกส์ของราชการ</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://www.zoothailand.org/more_news.php?cid=74">รายงานประจำปี</a>
                        </li>
                    </ul>
                </div>
            </div>
            <ul className="navbar-nav ms-auto">
                <li className="nav-item right-bg"><img src={Bgright} className="bg-image" /></li>
                <li className="nav-item bg-white"><a className="" href="/"><img src={LogoIta} className="ita-logo" /></a></li>
            </ul>
        </nav>
    )
}

export default LayoutHeader